/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-right': {
    width: 27,
    height: 26,
    viewBox: '0 0 27 26',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M16.273 11.932c.778.733.778 1.97 0 2.703l-5.234 4.933a.62.62 0 11-.85-.901l5.235-4.933a.62.62 0 000-.901L10.19 7.9a.62.62 0 01.849-.9l5.234 4.932z" _fill="#fff"/>'
  }
})
